export const markdownHeaderClasses = {
  h1: "heading-2xl",
  h2: "heading-xl",
  h3: "heading-lg",
  h4: "text-base font-semibold",
  h5: "text-sm font-semibold",
  h6: "text-sm font-regular italic"
};
export const markdownParagraphSize = "text-base leading-relaxed";
export const markdownTableClasses = {
  frame: "rounded-2xl border border-border-dark",
  cell: "border-border-dark px-4 py-3 align-top not-first:border-l",
  headerCell: "bg-muted-background text-left text-xs font-semibold text-muted-foreground"
};
//# sourceMappingURL=markdownSizes.js.map